export const SEND_FEEDBACK = 'feedbacks:SEND_FEEDBACK'
export const SEND_FEEDBACK_SUCCESS = 'feedbacks:SEND_FEEDBACK_SUCCESS'
export const SEND_FEEDBACK_FAILURE = 'feedbacks:SEND_FEEDBACK_FAILURE'

export const SET_FEEDBACK_SENT = 'feedbacks:SET_FEEDBACK_SENT'
